export const CASH_SETTLEMENT_VALUATION = [
  { id: 'MARKET', displayValue: 'Market' },
  { id: 'HIGHEST', displayValue: 'Highest' },
];
